import { useRouter } from "solito/router";

import type { FlowConfig, FlowStepBase } from "./common";

export const lookupFlowStep = <T extends FlowConfig<S>, S extends FlowStepBase>(
  flowConfig: T | undefined,
  step: string | undefined,
) => {
  if (!flowConfig) {
    throw new Error(`flow config not set looking up step ${step}`);
  }

  if (!step) {
    throw new Error(`undefined step: ${step}`);
  }

  const stepConfig = flowConfig.steps[step];

  if (!stepConfig) {
    throw new Error(`undefined step config for step ${step}`);
  }
  return stepConfig;
};

export const useBaseGotoFlowExit = <
  T extends FlowConfig<S>,
  S extends FlowStepBase,
>({
  isInitialized,
  flowConfig,
  reset,
  analyticsTrigger,
  errorUrl,
}: {
  isInitialized: boolean;
  flowConfig?: T;
  errorUrl: string;
  reset?: () => void;
  analyticsTrigger?: () => void;
}) => {
  const { replace } = useRouter();

  const gotoFlowExit = () => {
    try {
      if (!isInitialized) {
        throw new Error("flow not initialized");
      }

      if (!flowConfig) {
        throw new Error("flow config not found");
      }

      if (reset) {
        reset();
      }

      if (analyticsTrigger) {
        analyticsTrigger();
      }

      replace(flowConfig.config.exit);
    } catch (error) {
      console.error("error going to flow exit", error);
      replace(errorUrl);
    }
  };

  return gotoFlowExit;
};

export const useBaseGotoFlowInitialStep = <
  T extends FlowConfig<S>,
  S extends FlowStepBase,
>({
  isInitialized,
  flowConfig,
  errorUrl,
}: {
  isInitialized: boolean;
  flowConfig?: T;
  errorUrl: string;
}) => {
  const { replace } = useRouter();

  const gotoFlowInitialStep = () => {
    try {
      if (!isInitialized) {
        throw new Error("flow not initialized");
      }

      if (!flowConfig) {
        throw new Error("flow config not found");
      }

      const initialStep = flowConfig.config.initial;

      replace(`${flowConfig.config.basePath}/${initialStep}`);
    } catch (error) {
      console.error("error going to flow initial step", error);
      replace(errorUrl);
    }
  };

  return gotoFlowInitialStep;
};
